/**
 * Travel & places emoji category with searchable keywords
 */
export const travel = {
  name: 'Travel',
  icon: '✈️',
  emojis: [
    { emoji: '🚗', keywords: ['car', 'automobile', 'vehicle', 'drive', 'red'] },
    { emoji: '🚕', keywords: ['taxi', 'cab', 'car', 'ride', 'yellow'] },
    { emoji: '🚙', keywords: ['suv', 'car', 'vehicle', 'sport', 'utility'] },
    { emoji: '🚌', keywords: ['bus', 'vehicle', 'transport', 'public', 'school'] },
    { emoji: '🚎', keywords: ['trolleybus', 'bus', 'electric', 'transport', 'vehicle'] },
    { emoji: '🏎️', keywords: ['race', 'car', 'fast', 'formula', 'speed'] },
    { emoji: '🚓', keywords: ['police', 'car', 'cop', 'emergency', 'vehicle'] },
    { emoji: '🚑', keywords: ['ambulance', 'emergency', 'hospital', 'medical', 'vehicle'] },
    { emoji: '🚒', keywords: ['fire', 'truck', 'engine', 'emergency', 'vehicle'] },
    { emoji: '🚐', keywords: ['minibus', 'van', 'vehicle', 'transport', 'shuttle'] },
    { emoji: '🛻', keywords: ['pickup', 'truck', 'vehicle', 'haul', 'transport'] },
    { emoji: '🚚', keywords: ['truck', 'delivery', 'shipping', 'vehicle', 'moving'] },
    { emoji: '🚛', keywords: ['semi', 'truck', 'trailer', 'transport', 'haul'] },
    { emoji: '🚜', keywords: ['tractor', 'farm', 'vehicle', 'agriculture', 'machinery'] },
    { emoji: '🏍️', keywords: ['motorcycle', 'racing', 'bike', 'vehicle', 'fast'] },
    { emoji: '🛵', keywords: ['scooter', 'motor', 'vespa', 'vehicle', 'ride'] },
    { emoji: '🚲', keywords: ['bicycle', 'bike', 'cycling', 'ride', 'pedal'] },
    { emoji: '🛴', keywords: ['scooter', 'kick', 'ride', 'vehicle', 'transport'] },
    { emoji: '🛺', keywords: ['rickshaw', 'auto', 'tuk', 'vehicle', 'india'] },
    { emoji: '🚨', keywords: ['police', 'light', 'emergency', 'siren', 'alert'] },
    { emoji: '🚔', keywords: ['police', 'car', 'oncoming', 'emergency', 'cop'] },
    { emoji: '🚍', keywords: ['bus', 'oncoming', 'public', 'transport', 'vehicle'] },
    { emoji: '🚘', keywords: ['car', 'oncoming', 'automobile', 'vehicle', 'drive'] },
    { emoji: '🚖', keywords: ['taxi', 'oncoming', 'cab', 'ride', 'vehicle'] },
    { emoji: '🚡', keywords: ['cable', 'car', 'aerial', 'tramway', 'mountain'] },
    { emoji: '🚠', keywords: ['cable', 'car', 'mountain', 'gondola', 'lift'] },
    { emoji: '🚟', keywords: ['suspension', 'railway', 'monorail', 'transport', 'train'] },
    { emoji: '🚃', keywords: ['railway', 'car', 'train', 'passenger', 'transport'] },
    { emoji: '🚋', keywords: ['tram', 'car', 'streetcar', 'trolley', 'transport'] },
    { emoji: '🚞', keywords: ['mountain', 'railway', 'train', 'scenic', 'transport'] },
    { emoji: '🚝', keywords: ['monorail', 'train', 'transport', 'fast', 'modern'] },
    { emoji: '🚄', keywords: ['train', 'bullet', 'high', 'speed', 'shinkansen'] },
    { emoji: '🚅', keywords: ['train', 'bullet', 'fast', 'speed', 'shinkansen'] },
    { emoji: '🚈', keywords: ['train', 'light', 'rail', 'metro', 'transport'] },
    { emoji: '🚂', keywords: ['train', 'locomotive', 'steam', 'engine', 'railway'] },
    { emoji: '🚆', keywords: ['train', 'railway', 'transport', 'travel', 'station'] },
    { emoji: '🚇', keywords: ['metro', 'subway', 'underground', 'train', 'transport'] },
    { emoji: '🚊', keywords: ['tram', 'streetcar', 'trolley', 'transport', 'rail'] },
    { emoji: '🚉', keywords: ['station', 'train', 'railway', 'platform', 'transport'] },
    { emoji: '✈️', keywords: ['airplane', 'plane', 'flight', 'travel', 'fly'] },
    { emoji: '🛫', keywords: ['takeoff', 'airplane', 'departure', 'flight', 'travel'] },
    { emoji: '🛬', keywords: ['landing', 'airplane', 'arrival', 'flight', 'travel'] },
    { emoji: '🛩️', keywords: ['airplane', 'small', 'plane', 'private', 'flight'] },
    { emoji: '💺', keywords: ['seat', 'airplane', 'chair', 'travel', 'flight'] },
    { emoji: '🛰️', keywords: ['satellite', 'space', 'orbit', 'communication', 'gps'] },
    { emoji: '🚀', keywords: ['rocket', 'space', 'launch', 'nasa', 'spaceship'] },
    { emoji: '🛸', keywords: ['ufo', 'alien', 'flying', 'saucer', 'space'] },
    { emoji: '🚁', keywords: ['helicopter', 'chopper', 'fly', 'aircraft', 'transport'] },
    { emoji: '🛶', keywords: ['canoe', 'boat', 'paddle', 'kayak', 'water'] },
    { emoji: '⛵', keywords: ['sailboat', 'boat', 'sailing', 'yacht', 'water'] },
    { emoji: '🚤', keywords: ['speedboat', 'boat', 'fast', 'water', 'motor'] },
    { emoji: '🛥️', keywords: ['boat', 'motor', 'yacht', 'water', 'cruise'] },
    { emoji: '🛳️', keywords: ['ship', 'cruise', 'passenger', 'liner', 'travel'] },
    { emoji: '⛴️', keywords: ['ferry', 'boat', 'ship', 'water', 'transport'] },
    { emoji: '🚢', keywords: ['ship', 'boat', 'cruise', 'ocean', 'travel'] },
    { emoji: '⚓', keywords: ['anchor', 'ship', 'boat', 'nautical', 'dock'] },
    { emoji: '🪝', keywords: ['hook', 'fishing', 'hang', 'catch', 'tool'] },
    { emoji: '⛽', keywords: ['fuel', 'gas', 'pump', 'station', 'petrol'] },
    { emoji: '🚧', keywords: ['construction', 'barrier', 'road', 'work', 'warning'] },
    { emoji: '🚦', keywords: ['traffic', 'light', 'signal', 'stop', 'road'] },
    { emoji: '🚥', keywords: ['traffic', 'light', 'horizontal', 'signal', 'road'] },
    { emoji: '🚏', keywords: ['bus', 'stop', 'station', 'sign', 'transport'] },
    { emoji: '🗺️', keywords: ['map', 'world', 'travel', 'geography', 'explore'] },
    { emoji: '🗿', keywords: ['moai', 'easter', 'island', 'statue', 'stone'] },
    { emoji: '🗽', keywords: ['statue', 'liberty', 'nyc', 'america', 'landmark'] },
    { emoji: '🗼', keywords: ['tower', 'tokyo', 'landmark', 'japan', 'red'] },
    { emoji: '🏰', keywords: ['castle', 'european', 'medieval', 'fairy', 'tale'] },
    { emoji: '🏯', keywords: ['castle', 'japanese', 'landmark', 'japan', 'palace'] },
    { emoji: '🏟️', keywords: ['stadium', 'arena', 'sports', 'venue', 'concert'] },
    { emoji: '🎡', keywords: ['ferris', 'wheel', 'carnival', 'fair', 'amusement'] },
    { emoji: '🎢', keywords: ['roller', 'coaster', 'amusement', 'park', 'ride'] },
    { emoji: '🎠', keywords: ['carousel', 'horse', 'merry', 'go', 'round'] },
    { emoji: '⛲', keywords: ['fountain', 'water', 'park', 'plaza', 'decoration'] },
    { emoji: '⛱️', keywords: ['umbrella', 'beach', 'sun', 'shade', 'vacation'] },
    { emoji: '🏖️', keywords: ['beach', 'umbrella', 'vacation', 'sand', 'ocean'] },
    { emoji: '🏝️', keywords: ['island', 'desert', 'tropical', 'palm', 'vacation'] },
    { emoji: '🏜️', keywords: ['desert', 'sand', 'dry', 'hot', 'cactus'] },
    { emoji: '🌋', keywords: ['volcano', 'eruption', 'lava', 'mountain', 'nature'] },
    { emoji: '⛰️', keywords: ['mountain', 'peak', 'nature', 'hike', 'climb'] },
    { emoji: '🏔️', keywords: ['mountain', 'snow', 'peak', 'alps', 'nature'] },
    { emoji: '🗻', keywords: ['fuji', 'mountain', 'japan', 'snow', 'landmark'] },
    { emoji: '🏕️', keywords: ['camping', 'tent', 'outdoor', 'nature', 'adventure'] },
    { emoji: '⛺', keywords: ['tent', 'camping', 'outdoor', 'nature', 'camp'] },
    { emoji: '🛖', keywords: ['hut', 'house', 'shelter', 'primitive', 'home'] },
    { emoji: '🏠', keywords: ['house', 'home', 'building', 'residence', 'property'] },
    { emoji: '🏡', keywords: ['house', 'garden', 'home', 'yard', 'property'] },
    { emoji: '🏘️', keywords: ['houses', 'neighborhood', 'suburb', 'community', 'homes'] },
    { emoji: '🏚️', keywords: ['house', 'derelict', 'abandoned', 'old', 'haunted'] },
    { emoji: '🏗️', keywords: ['construction', 'building', 'crane', 'site', 'work'] },
    { emoji: '🏭', keywords: ['factory', 'industrial', 'building', 'manufacturing', 'smoke'] },
    { emoji: '🏢', keywords: ['office', 'building', 'work', 'business', 'corporate'] },
    { emoji: '🏬', keywords: ['department', 'store', 'mall', 'shopping', 'building'] },
    { emoji: '🏣', keywords: ['post', 'office', 'japanese', 'mail', 'building'] },
    { emoji: '🏤', keywords: ['post', 'office', 'european', 'mail', 'building'] },
    { emoji: '🏥', keywords: ['hospital', 'medical', 'building', 'health', 'emergency'] },
    { emoji: '🏦', keywords: ['bank', 'building', 'money', 'finance', 'institution'] },
    { emoji: '🏨', keywords: ['hotel', 'building', 'accommodation', 'travel', 'stay'] },
    { emoji: '🏪', keywords: ['convenience', 'store', 'shop', 'building', '24'] },
    { emoji: '🏫', keywords: ['school', 'building', 'education', 'learn', 'campus'] },
    { emoji: '🏩', keywords: ['love', 'hotel', 'building', 'romance', 'heart'] },
    { emoji: '💒', keywords: ['wedding', 'chapel', 'church', 'marriage', 'love'] },
    { emoji: '🏛️', keywords: ['classical', 'building', 'museum', 'government', 'columns'] },
    { emoji: '⛪', keywords: ['church', 'religion', 'christian', 'building', 'worship'] },
    { emoji: '🕌', keywords: ['mosque', 'islam', 'muslim', 'religion', 'building'] },
    { emoji: '🕍', keywords: ['synagogue', 'jewish', 'temple', 'religion', 'building'] },
    { emoji: '⛩️', keywords: ['shinto', 'shrine', 'japanese', 'torii', 'religion'] },
    { emoji: '🕋', keywords: ['kaaba', 'mecca', 'islam', 'muslim', 'holy'] },
  ],
};

export default travel;

